/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-05-11 15:13:18
 */
import { Component, EventEmitter, forwardRef, Input, OnChanges, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';

import { ControlValueAccessorService } from '../../control-value-accessor.service';
import { FORM_CONSTANTS } from './../../form-constant';

type dtUploadType = 'iconModal' | 'buttonModal' | 'buttonList' | 'pictureCard';

@Component({
  selector: 'dt-form-upload',
  templateUrl: './form-upload.component.html',
  styleUrls: ['./form-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormUploadComponent),
      multi: true,
    },
  ],
})
export class FormUploadComponent extends ControlValueAccessorService implements OnChanges {
  // {"status":true,"code":"0000","messages":"",
  // "data":[{"id":null,"createDate":"1590389534635","createUser":"system","updateDate":null,"updateUser":"system","fileId":"5ecb6b1e1c52d9000bb0ac9a","fileName":"1588040988(1).png","fileSize":57592,"contentType":"png","type":"ATTACHMENT","delete":false,"endCreateDate":null,"description":null,"createUserName":null,"createPersonName":null,"path":"/ATTACHMENT/20200525/5ecb6b1e1c52d9000bb0ac9b.png","businessId":null}],"page":0,"record":0,"total":0}
  // æ§ä»¶ç±»å
  value: any;
  @Input() type: dtUploadType = 'buttonModal';
  // æ¥åä¸ä¼ çæä»¶ç±»å  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-accept   https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
  @Input() acceptType: string;
  // ç¦æ­¢ä¸ä¼ çæä»¶ç±»åï¼ä¾å¦ï¼image/png,image/jpeg,image/gif,image/bmp
  @Input() banType: string;
  // ä¸ä¼ æä»¶è¯·æ±çapi
  @Input() reqUrl = this.settingsSrv.userConfig['pages'] && this.settingsSrv.userConfig['pages'].upload;
  @Input() downloadUrl = '';
  // æ¥åä¸ä¼ çæä»¶å¤§å°ï¼åä½kb,é»è®¤100M
  @Input() size = 102400;
  // ä¸ä¼ åè¡¨çåå»ºæ ·å¼ï¼æ¯æä¸ç§åºæ¬æ ·å¼ text, picture å picture-card
  @Input() nzListType = 'picture';
  // ä¸ä¼ åè¡¨çæ ·å¼ï¼æ¯æä¸ç§åºæ¬æ ·å¼ text, picture å picture-card
  @Input() showType = 'picture';
  // æ¯å¦æ¯æå¤ä¸ªä¸ä¼ 
  @Input() multiple = true;
  // æ¯å¦ç¦ç¨
  @Input() disabled = false;

  // æ¨¡ææ¡æ é¢
  @Input() title = 'fileUpload.upload';
  // æ¯å¦æ¾ç¤ºæé®ï¼ä¸ç¶åªæ¾ç¤ºå¾æ 
  @Input() showBtn = false;
  // æé®åç§°
  @Input() btnName = 'fileUpload.upload';
  // åªæ¾ç¤ºå¾æ æ¶å¾æ æ ·å¼:{'color': '#0061aa'}
  @Input() onlyIconStyle: object;
  // è¥ä¸æ³ç¨æé®ä¹ä¸æ³ç¨å¾æ èªå®ä¹æé®ï¼åè®¾ç½®æ­¤é¡¹ä¸ºtrue
  @Input() customContent = false;
  // æç¤ºæå­
  @Input() tips = 'fileUpload.supportDocuments';
  // å¾çä¸åè®¸éå¤ï¼è¥æéå¤çåå é¤
  @Input() deleteUniqFile = true;
  // æ¯æä¸ä¼ æä»¶å¤¹
  @Input() nzDirectory = false;
  // éå¶åæ¶ä¸ä¼ æä»¶æ°ï¼é»è®¤ä¸éå¶
  @Input() nzLimit = 0;
  @Input() needToken = true;
  @Input() onBeforeUpload: any;
  @Input() prop = '';
  @Output() valueChange = new EventEmitter<any>();

  stagingData = [];
  firstList = [];
  // é¢è§
  previewVisible = false;
  // é¢è§å¾ç
  previewImage: string;

  constructor(private settingsSrv: SettingsService) {
    super();
  }
  ngOnChanges(changes): void {
    if (changes['value'] && changes['value'].currentValue) {
    }
  }

  upload(res) {
    if (res.status) {
      const stagingData = [...this.stagingData, ...this.handleViewUrl(res.data)];
      this.stagingData = stagingData.slice(-this.nzLimit);
      this.writeValue(this.stagingData);
      this.updateChanges();
      this.firstList = this.value[0] ? this.value[0] : [];
      this.valueChange.emit(this.value);
    }
  }

  // å¤çé¡µé¢å±ç¤ºå¾ççè·¯å¾
  handleViewUrl(item) {
    const token = this.settingsSrv.token;
    const file = this.settingsSrv.userConfig['env'].serverName.file;
    const urlNoToken = FORM_CONSTANTS.imgDown;
    const urlToken = FORM_CONSTANTS.showImage;
    if (this.needToken) {
      item[0].logo = `${file}${urlToken}${token}&fileId=${item[0].fileId}`;
    } else {
      item[0].logo = `${file}${urlNoToken}${item[0].fileId}`;
    }
    return item;
  }
  download(item) {
    if (this.nzListType === 'picture' && item && this.downloadUrl) {
      this.previewImage = this.downloadUrl + item.fileId;
      this.previewVisible = true;
    } else if (this.downloadUrl && item) {
      window.open(this.downloadUrl + item.fileId, '_blank');
    }
  }

  // å é¤äºä»¶
  removeUpload(item) {
    const arr = [];
    this.stagingData.map((t) => {
      if (t.fileId !== item.fileId) {
        arr.push(t);
      }
    });
    this.stagingData = arr;
    this.writeValue(this.stagingData);
    this.updateChanges();
    this.firstList = this.value[0] ? this.value[0] : [];
  }

  // é¢è§æä½
  async preview(item) {
    if (item.logo) {
      item.logo = await item.logo;
    }
    this.previewImage = item.logo;
    this.previewVisible = true;
  }
}
